import {
  // Documents & Notes
  FileText,
  File,
  FileEdit,
  Clipboard,
  ClipboardList,
  StickyNote,
  ScrollText,
  NotebookPen,
  BookMarked,
  FileCode,
  FileJson,

  // Folders
  Folder,
  FolderOpen,
  FolderArchive,
  FolderClosed,
  Folders,

  // Stars & Favorites
  Star,
  Sparkles,
  Heart,
  Pin,
  Bookmark,

  // Status & Priority
  CheckCircle,
  XCircle,
  AlertTriangle,
  AlertCircle,
  Info,
  CircleDot,
  Circle,
  ShieldCheck,
  ShieldAlert,
  BadgeCheck,

  // Communication
  MessageCircle,
  MessageSquare,
  Mail,
  Bell,
  BellRing,
  AtSign,

  // Date & Time
  Calendar,
  CalendarDays,
  Clock,
  AlarmClock,
  Hourglass,
  Timer,

  // Tools & Settings
  Wrench,
  Settings,
  Search,
  Key,
  Lock,
  Unlock,
  Paperclip,
  Link,
  Tag,
  Hash,
  Flag,
  Filter,

  // Ideas & Thinking
  Lightbulb,
  Brain,
  Target,
  Zap,
  Flame,
  Droplets,
  Compass,

  // Charts & Data
  BarChart3,
  TrendingUp,
  TrendingDown,
  PieChart,
  LineChart,
  Database,
  Table,

  // Tech
  Laptop,
  Monitor,
  Smartphone,
  HardDrive,
  Cloud,
  Wifi,
  Globe,
  Server,

  // Nature
  Leaf,
  Flower,
  Sun,
  CloudSun,
  Moon,
  Umbrella,

  // Finance
  DollarSign,
  CreditCard,
  Wallet,
  PiggyBank,
  Receipt,

  // Home & Living
  Home,
  Building,
  Bed,
  Coffee,

  // Education
  GraduationCap,
  Book,
  BookOpen,
  PenTool,

  // Media
  Music,
  Camera,
  Video,
  Palette,
  Image,
  Film,
  Mic,

  // Travel
  Map,
  MapPin,
  Plane,
  Car,
  Ship,
  Navigation,

  // Health
  Activity,
  HeartPulse,
  Pill,
  Dumbbell,

  // Misc
  Rocket,
  ThumbsUp,
  ThumbsDown,
  Bug,
  Code,
  GitBranch,
  Terminal,
  Package,
  ShoppingCart,
  ShoppingBag,
  Gift,
} from 'lucide-react';

/**
 * Name-to-component lookup map.
 * Key = icon name string (kebab-case, no prefix), Value = Lucide component.
 *
 * Example: FEATHER_MAP['star'] → Star
 */
const FEATHER_MAP = {
  // Documents & Notes
  'file-text': FileText,
  'file': File,
  'file-edit': FileEdit,
  'clipboard': Clipboard,
  'clipboard-list': ClipboardList,
  'sticky-note': StickyNote,
  'scroll-text': ScrollText,
  'notebook-pen': NotebookPen,
  'book-marked': BookMarked,
  'file-code': FileCode,
  'file-json': FileJson,

  // Folders
  'folder': Folder,
  'folder-open': FolderOpen,
  'folder-archive': FolderArchive,
  'folder-closed': FolderClosed,
  'folders': Folders,

  // Stars & Favorites
  'star': Star,
  'sparkles': Sparkles,
  'heart': Heart,
  'pin': Pin,
  'bookmark': Bookmark,

  // Status & Priority
  'check-circle': CheckCircle,
  'x-circle': XCircle,
  'alert-triangle': AlertTriangle,
  'alert-circle': AlertCircle,
  'info': Info,
  'circle-dot': CircleDot,
  'circle': Circle,
  'shield-check': ShieldCheck,
  'shield-alert': ShieldAlert,
  'badge-check': BadgeCheck,

  // Communication
  'message-circle': MessageCircle,
  'message-square': MessageSquare,
  'mail': Mail,
  'bell': Bell,
  'bell-ring': BellRing,
  'at-sign': AtSign,

  // Date & Time
  'calendar': Calendar,
  'calendar-days': CalendarDays,
  'clock': Clock,
  'alarm-clock': AlarmClock,
  'hourglass': Hourglass,
  'timer': Timer,

  // Tools & Settings
  'wrench': Wrench,
  'settings': Settings,
  'search': Search,
  'key': Key,
  'lock': Lock,
  'unlock': Unlock,
  'paperclip': Paperclip,
  'link': Link,
  'tag': Tag,
  'hash': Hash,
  'flag': Flag,
  'filter': Filter,

  // Ideas & Thinking
  'lightbulb': Lightbulb,
  'brain': Brain,
  'target': Target,
  'zap': Zap,
  'flame': Flame,
  'droplets': Droplets,
  'compass': Compass,

  // Charts & Data
  'bar-chart-3': BarChart3,
  'trending-up': TrendingUp,
  'trending-down': TrendingDown,
  'pie-chart': PieChart,
  'line-chart': LineChart,
  'database': Database,
  'table': Table,

  // Tech
  'laptop': Laptop,
  'monitor': Monitor,
  'smartphone': Smartphone,
  'hard-drive': HardDrive,
  'cloud': Cloud,
  'wifi': Wifi,
  'globe': Globe,
  'server': Server,

  // Nature
  'leaf': Leaf,
  'flower': Flower,
  'sun': Sun,
  'cloud-sun': CloudSun,
  'moon': Moon,
  'umbrella': Umbrella,

  // Finance
  'dollar-sign': DollarSign,
  'credit-card': CreditCard,
  'wallet': Wallet,
  'piggy-bank': PiggyBank,
  'receipt': Receipt,

  // Home & Living
  'home': Home,
  'building': Building,
  'bed': Bed,
  'coffee': Coffee,

  // Education
  'graduation-cap': GraduationCap,
  'book': Book,
  'book-open': BookOpen,
  'pen-tool': PenTool,

  // Media
  'music': Music,
  'camera': Camera,
  'video': Video,
  'palette': Palette,
  'image': Image,
  'film': Film,
  'mic': Mic,

  // Travel
  'map': Map,
  'map-pin': MapPin,
  'plane': Plane,
  'car': Car,
  'ship': Ship,
  'navigation': Navigation,

  // Health
  'activity': Activity,
  'heart-pulse': HeartPulse,
  'pill': Pill,
  'dumbbell': Dumbbell,

  // Misc
  'rocket': Rocket,
  'thumbs-up': ThumbsUp,
  'thumbs-down': ThumbsDown,
  'bug': Bug,
  'code': Code,
  'git-branch': GitBranch,
  'terminal': Terminal,
  'package': Package,
  'shopping-cart': ShoppingCart,
  'shopping-bag': ShoppingBag,
  'gift': Gift,
};

/**
 * Icon options for the picker UI — ordered by category.
 * Each entry: { name, label, Icon }
 */
const FEATHER_OPTIONS = [
  // Documents & Notes
  { name: 'file-text', label: 'File text', Icon: FileText },
  { name: 'file', label: 'File', Icon: File },
  { name: 'file-edit', label: 'File edit', Icon: FileEdit },
  { name: 'clipboard', label: 'Clipboard', Icon: Clipboard },
  { name: 'clipboard-list', label: 'Clipboard list', Icon: ClipboardList },
  { name: 'sticky-note', label: 'Sticky note', Icon: StickyNote },
  { name: 'scroll-text', label: 'Scroll', Icon: ScrollText },
  { name: 'notebook-pen', label: 'Notebook', Icon: NotebookPen },
  { name: 'book-marked', label: 'Book marked', Icon: BookMarked },
  { name: 'file-code', label: 'File code', Icon: FileCode },
  { name: 'file-json', label: 'File JSON', Icon: FileJson },

  // Folders
  { name: 'folder', label: 'Folder', Icon: Folder },
  { name: 'folder-open', label: 'Folder open', Icon: FolderOpen },
  { name: 'folder-archive', label: 'Archive', Icon: FolderArchive },
  { name: 'folder-closed', label: 'Folder closed', Icon: FolderClosed },
  { name: 'folders', label: 'Folders', Icon: Folders },

  // Stars & Favorites
  { name: 'star', label: 'Star', Icon: Star },
  { name: 'sparkles', label: 'Sparkles', Icon: Sparkles },
  { name: 'heart', label: 'Heart', Icon: Heart },
  { name: 'pin', label: 'Pin', Icon: Pin },
  { name: 'bookmark', label: 'Bookmark', Icon: Bookmark },

  // Status & Priority
  { name: 'check-circle', label: 'Check', Icon: CheckCircle },
  { name: 'x-circle', label: 'X circle', Icon: XCircle },
  { name: 'alert-triangle', label: 'Warning', Icon: AlertTriangle },
  { name: 'alert-circle', label: 'Alert', Icon: AlertCircle },
  { name: 'info', label: 'Info', Icon: Info },
  { name: 'circle-dot', label: 'Circle dot', Icon: CircleDot },
  { name: 'circle', label: 'Circle', Icon: Circle },
  { name: 'shield-check', label: 'Shield', Icon: ShieldCheck },
  { name: 'shield-alert', label: 'Shield alert', Icon: ShieldAlert },
  { name: 'badge-check', label: 'Badge', Icon: BadgeCheck },

  // Communication
  { name: 'message-circle', label: 'Comment', Icon: MessageCircle },
  { name: 'message-square', label: 'Message', Icon: MessageSquare },
  { name: 'mail', label: 'Mail', Icon: Mail },
  { name: 'bell', label: 'Bell', Icon: Bell },
  { name: 'bell-ring', label: 'Bell ring', Icon: BellRing },
  { name: 'at-sign', label: 'At sign', Icon: AtSign },

  // Date & Time
  { name: 'calendar', label: 'Calendar', Icon: Calendar },
  { name: 'calendar-days', label: 'Calendar days', Icon: CalendarDays },
  { name: 'clock', label: 'Clock', Icon: Clock },
  { name: 'alarm-clock', label: 'Alarm', Icon: AlarmClock },
  { name: 'hourglass', label: 'Hourglass', Icon: Hourglass },
  { name: 'timer', label: 'Timer', Icon: Timer },

  // Tools & Settings
  { name: 'wrench', label: 'Wrench', Icon: Wrench },
  { name: 'settings', label: 'Settings', Icon: Settings },
  { name: 'search', label: 'Search', Icon: Search },
  { name: 'key', label: 'Key', Icon: Key },
  { name: 'lock', label: 'Lock', Icon: Lock },
  { name: 'unlock', label: 'Unlock', Icon: Unlock },
  { name: 'paperclip', label: 'Paperclip', Icon: Paperclip },
  { name: 'link', label: 'Link', Icon: Link },
  { name: 'tag', label: 'Tag', Icon: Tag },
  { name: 'hash', label: 'Hash', Icon: Hash },
  { name: 'flag', label: 'Flag', Icon: Flag },
  { name: 'filter', label: 'Filter', Icon: Filter },

  // Ideas & Thinking
  { name: 'lightbulb', label: 'Lightbulb', Icon: Lightbulb },
  { name: 'brain', label: 'Brain', Icon: Brain },
  { name: 'target', label: 'Target', Icon: Target },
  { name: 'zap', label: 'Zap', Icon: Zap },
  { name: 'flame', label: 'Flame', Icon: Flame },
  { name: 'droplets', label: 'Droplets', Icon: Droplets },
  { name: 'compass', label: 'Compass', Icon: Compass },

  // Charts & Data
  { name: 'bar-chart-3', label: 'Bar chart', Icon: BarChart3 },
  { name: 'trending-up', label: 'Trending up', Icon: TrendingUp },
  { name: 'trending-down', label: 'Trending down', Icon: TrendingDown },
  { name: 'pie-chart', label: 'Pie chart', Icon: PieChart },
  { name: 'line-chart', label: 'Line chart', Icon: LineChart },
  { name: 'database', label: 'Database', Icon: Database },
  { name: 'table', label: 'Table', Icon: Table },

  // Tech
  { name: 'laptop', label: 'Laptop', Icon: Laptop },
  { name: 'monitor', label: 'Monitor', Icon: Monitor },
  { name: 'smartphone', label: 'Phone', Icon: Smartphone },
  { name: 'hard-drive', label: 'Hard drive', Icon: HardDrive },
  { name: 'cloud', label: 'Cloud', Icon: Cloud },
  { name: 'wifi', label: 'WiFi', Icon: Wifi },
  { name: 'globe', label: 'Globe', Icon: Globe },
  { name: 'server', label: 'Server', Icon: Server },

  // Nature
  { name: 'leaf', label: 'Leaf', Icon: Leaf },
  { name: 'flower', label: 'Flower', Icon: Flower },
  { name: 'sun', label: 'Sun', Icon: Sun },
  { name: 'cloud-sun', label: 'Cloud sun', Icon: CloudSun },
  { name: 'moon', label: 'Moon', Icon: Moon },
  { name: 'umbrella', label: 'Umbrella', Icon: Umbrella },

  // Finance
  { name: 'dollar-sign', label: 'Dollar', Icon: DollarSign },
  { name: 'credit-card', label: 'Credit card', Icon: CreditCard },
  { name: 'wallet', label: 'Wallet', Icon: Wallet },
  { name: 'piggy-bank', label: 'Piggy bank', Icon: PiggyBank },
  { name: 'receipt', label: 'Receipt', Icon: Receipt },

  // Home & Living
  { name: 'home', label: 'Home', Icon: Home },
  { name: 'building', label: 'Building', Icon: Building },
  { name: 'bed', label: 'Bed', Icon: Bed },
  { name: 'coffee', label: 'Coffee', Icon: Coffee },

  // Education
  { name: 'graduation-cap', label: 'Graduation', Icon: GraduationCap },
  { name: 'book', label: 'Book', Icon: Book },
  { name: 'book-open', label: 'Book open', Icon: BookOpen },
  { name: 'pen-tool', label: 'Pen tool', Icon: PenTool },

  // Media
  { name: 'music', label: 'Music', Icon: Music },
  { name: 'camera', label: 'Camera', Icon: Camera },
  { name: 'video', label: 'Video', Icon: Video },
  { name: 'palette', label: 'Palette', Icon: Palette },
  { name: 'image', label: 'Image', Icon: Image },
  { name: 'film', label: 'Film', Icon: Film },
  { name: 'mic', label: 'Microphone', Icon: Mic },

  // Travel
  { name: 'map', label: 'Map', Icon: Map },
  { name: 'map-pin', label: 'Map pin', Icon: MapPin },
  { name: 'plane', label: 'Plane', Icon: Plane },
  { name: 'car', label: 'Car', Icon: Car },
  { name: 'ship', label: 'Ship', Icon: Ship },
  { name: 'navigation', label: 'Navigation', Icon: Navigation },

  // Health
  { name: 'activity', label: 'Activity', Icon: Activity },
  { name: 'heart-pulse', label: 'Heart pulse', Icon: HeartPulse },
  { name: 'pill', label: 'Pill', Icon: Pill },
  { name: 'dumbbell', label: 'Dumbbell', Icon: Dumbbell },

  // Misc
  { name: 'rocket', label: 'Rocket', Icon: Rocket },
  { name: 'thumbs-up', label: 'Thumbs up', Icon: ThumbsUp },
  { name: 'thumbs-down', label: 'Thumbs down', Icon: ThumbsDown },
  { name: 'bug', label: 'Bug', Icon: Bug },
  { name: 'code', label: 'Code', Icon: Code },
  { name: 'git-branch', label: 'Git branch', Icon: GitBranch },
  { name: 'terminal', label: 'Terminal', Icon: Terminal },
  { name: 'package', label: 'Package', Icon: Package },
  { name: 'shopping-cart', label: 'Shopping cart', Icon: ShoppingCart },
  { name: 'shopping-bag', label: 'Shopping bag', Icon: ShoppingBag },
  { name: 'gift', label: 'Gift', Icon: Gift },
];

export { FEATHER_MAP, FEATHER_OPTIONS };
